import { render, staticRenderFns } from "./booking-side-panel.vue?vue&type=template&id=7c6bf3a4&scoped=true&"
import script from "./booking-side-panel.vue?vue&type=script&lang=js&"
export * from "./booking-side-panel.vue?vue&type=script&lang=js&"
import style0 from "./booking-side-panel.vue?vue&type=style&index=0&id=7c6bf3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6bf3a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VDivider,VNavigationDrawer,VTab,VTabs,VTabsItems})
